var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad id perspiciatis ullam natus velit libero, quam non sunt dolor nesciunt quisquam sit corporis a minima iusto eaque. Illum, dicta culpa! ")])}
var staticRenderFns = []

export { render, staticRenderFns }